<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="grey darken-3"
          icon="mdi-account"
          :title="formValues.name"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <template v-else>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  target="_blank"
                  :href="
                    '/excelExport/' +
                      this.formValues.id +
                      '?token=' +
                      this.token
                  "
                  >Export</v-btn
                >
                <v-btn
                  target="_blank"
                  :href="
                    '/excelExport/' +
                      this.formValues.id +
                      '/presence?token=' +
                      this.token
                  "
                  >Präsenzliste</v-btn
                >
                <!--<v-btn
                  target="_blank"
                  :href="
                    '/excelExport/' +
                      this.formValues.id +
                      '?token=' +
                      this.token
                  "
                  >Teilnehmerliste</v-btn
                >-->
              </v-col>
            </v-row>
            <p v-if="formValues.max_participants">
              <strong>{{ $t("max_participants") }}: </strong
              >{{ formValues.max_participants }}
            </p>

            <v-card
              v-for="(item, index) in formValues.courseWeeks"
              :key="index"
              color="grey lighten-3"
            >
              <v-card-title class="pt-3"
                >{{ item.name }}
                <v-chip dark class="ml-2"
                  >{{ item.from | formatDate }} -
                  {{ item.to | formatDate }}</v-chip
                >
                <v-spacer />
                <v-btn
                  small
                  target="_blank"
                  color="primary"
                  @click="showRegisterChildDialog(item)"
                >
                  <v-icon class="mr-1">mdi-account-plus</v-icon>
                  {{ $t("register_child") }}
                </v-btn>
              </v-card-title>
              <v-card-text>
                <hr class="mb-2 mt-2" />

                <p v-if="item.max_participants">
                  <strong>{{ $t("max_participants") }}: </strong
                  >{{ item.registered }} /
                  {{ item.max_participants }}
                </p>
                <p v-if="item.waiting_list">
                  <strong>{{ $t("waiting_list") }}: </strong
                  >{{ item.waiting }} /
                  {{ item.waiting_list }}
                </p>

                <v-expansion-panels class="mb-5">
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      ><b>Teilnehmer</b></v-expansion-panel-header
                    >

                    <v-expansion-panel-content
                      v-if="
                        item.registered_participants &&
                          item.registered_participants.length
                      "
                    >
                      <v-data-table
                        disable-pagination
                        hide-default-footer
                        background="white"
                        :headers="headers"
                        :items="item.registered_participants"
                      >
                        <template v-slot:item.action="{ item }">
                          <v-icon small @click="deleteItem(item)">
                            mdi-delete
                          </v-icon>
                   
                          <v-tooltip bottom v-if="item.pivot.comment">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon 
                                small
                                class="mr-2"
                                color="secondary"
                                dark
                                v-bind="attrs"
                                v-on="on"
                                >
                                mdi-information
                              </v-icon>
                              </template>
                              <span>{{ item.pivot.comment }}</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="item.pivot.medicaments || item.pivot.incompatibilities || item.pivot.allergies">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon 
                                  small
                                  class="mr-2"
                                  color="primary"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                  >
                                  mdi-information
                                </v-icon>
                                </template>
                                <span>{{ item.pivot.medicaments }} | {{ item.pivot.incompatibilities }} | {{ item.pivot.allergies }} </span>
                              </v-tooltip>
                        </template>
                        <template v-slot:item.is_waiting="{ item }">
                          <span v-if="item.pivot.is_waiting">{{
                            $t("yes")
                          }}</span>
                          <span v-else>{{ $t("no") }}</span>
                        </template>
                        <template v-slot:item.created_at="{ item }">
                          {{ item.created_at | formatDateTime }}
                        </template>
                        <template v-slot:item.pivot.day_type="{ item }">
                          <template v-if="item.pivot.day_type == 'half_day'">
                            {{
                              $i18n.locale == "de"
                                ? formValues.label_half_day_de
                                : formValues.label_half_day_it
                            }}
                          </template>
                          <template v-else>
                            {{
                              $i18n.locale == "de"
                                ? formValues.label_full_day_de
                                : formValues.label_full_day_it
                            }}
                          </template>
                        </template>
                        <template v-slot:item.pivot.emergency_contact1_phone="{ item }">
                          {{ item.pivot.emergency_contact1_phone }} / {{ item.pivot.emergency_contact2_phone }}
                        </template>
                        <template v-slot:item.pivot.payed_amount="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                color="green"
                                v-bind="attrs"
                                v-on="on"
                                v-if="item.pivot.payed_amount > 0"
                              >
                                mdi-check
                              </v-icon>
                              <v-icon
                                color="red"
                                dark
                                v-bind="attrs"
                                v-on="on"
                                v-else-if="item.pivot.payed_amount !== null"
                              >
                                mdi-exclamation
                              </v-icon>
                              <v-icon
                                color="red"
                                dark
                                v-bind="attrs"
                                v-on="on"
                                v-else
                              >
                                mdi-close
                              </v-icon>
                            </template>
                            <span v-if="item.pivot.payed_amount">{{
                              item.pivot.payed_amount | currency
                            }}</span>
                            <span v-else>0 €</span> /
                            <span v-if="item.pivot.day_type == 'full_day'">
                            {{ formValues.courseWeeks[index].price | currency }}</span>
                            <span v-else>{{ formValues.courseWeeks[index].price_half_day | currency }}</span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </v-expansion-panel-content>

                    <v-expansion-panel-content v-else>
                      <v-alert>{{ $t("no_course_registrations") }}</v-alert>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

                <v-expansion-panels class="mt-5">
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      ><b>Warteliste</b></v-expansion-panel-header
                    >

                    <v-expansion-panel-content
                      v-if="
                        item.waiting_queue_participants &&
                          item.waiting_queue_participants.length
                      "
                    >
                      <v-data-table
                        disable-pagination
                        hide-default-footer
                        :headers="headers"
                        :items="item.waiting_queue_participants"
                      >
                        <template v-slot:item.action="{ item }">
                          <v-icon small @click="deleteItem(item)">
                            mdi-delete
                          </v-icon>
                        </template>
                        <template v-slot:item.is_waiting="{ item }">
                          <span v-if="item.pivot.is_waiting">{{
                            $t("yes")
                          }}</span>
                          <span v-else>{{ $t("no") }}</span>
                        </template>
                        <template v-slot:item.created_at="{ item }">
                          {{ item.created_at | formatDateTime }}
                        </template>
                        <template v-slot:item.pivot.day_type="{ item }">
                          <template v-if="item.pivot.day_type == 'half_day'">
                            {{
                              $i18n.locale == "de"
                                ? formValues.label_half_day_de
                                : formValues.label_half_day_it
                            }}
                          </template>
                          <template v-else>
                            {{
                              $i18n.locale == "de"
                                ? formValues.label_full_day_de
                                : formValues.label_full_day_it
                            }}
                          </template>
                        </template>
                        <template v-slot:item.pivot.payed_amount="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                color="green"
                                v-bind="attrs"
                                v-on="on"
                                v-if="item.pivot.payed_amount > 0"
                              >
                                mdi-check
                              </v-icon>
                              <v-icon
                                color="red"
                                dark
                                v-bind="attrs"
                                v-on="on"
                                v-else-if="item.pivot.payed_amount !== null"
                              >
                                mdi-exclamation
                              </v-icon>
                              <v-icon
                                color="red"
                                dark
                                v-bind="attrs"
                                v-on="on"
                                v-else
                              >
                                mdi-close
                              </v-icon>
                            </template>
                            <span v-if="item.pivot.payed_amount">{{
                              item.pivot.payed_amount | currency
                            }}</span>
                            <span v-else>0 €</span> /
                            <span v-if="item.pivot.day_type == 'full_day'">
                            {{ formValues.courseWeeks[index].price | currency }}</span>
                            <span v-else>{{ formValues.courseWeeks[index].price_half_day | currency }}</span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </v-expansion-panel-content>

                    <v-expansion-panel-content v-else>
                      <v-alert>{{ $t("no_course_registrations") }}</v-alert>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

                <v-expansion-panels class="mt-5">
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      ><b>Gelöschte Anmeldungen</b></v-expansion-panel-header
                    >

                    <v-expansion-panel-content
                      v-if="
                        item.deleted_participants &&
                          item.deleted_participants.length
                      "
                    >
                      <v-data-table
                        disable-pagination
                        hide-default-footer
                        :headers="headers"
                        :items="item.deleted_participants"
                      >
                        <template v-slot:item.is_waiting="{ item }">
                          <span v-if="item.pivot.is_waiting">{{
                            $t("yes")
                          }}</span>
                          <span v-else>{{ $t("no") }}</span>
                        </template>
                        <template v-slot:item.pivot.created_at="{ item }">
                          Angemeldet: {{ item.pivot.created_at | formatDateTime }}<br>
                          Abgemeldet: {{ item.pivot.deleted_at | formatDateTime }}
                        </template>
                        <template v-slot:item.pivot.day_type="{ item }">
                          <template v-if="item.pivot.day_type == 'half_day'">
                            {{
                              $i18n.locale == "de"
                                ? formValues.label_half_day_de
                                : formValues.label_half_day_it
                            }}
                          </template>
                          <template v-else>
                            {{
                              $i18n.locale == "de"
                                ? formValues.label_full_day_de
                                : formValues.label_full_day_it
                            }}
                          </template>
                        </template>
                        <template v-slot:item.pivot.payed_amount="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                color="green"
                                v-bind="attrs"
                                v-on="on"
                                v-if="item.pivot.payed_amount > 0"
                              >
                                mdi-check
                              </v-icon>
                              <v-icon
                                color="red"
                                dark
                                v-bind="attrs"
                                v-on="on"
                                v-else-if="item.pivot.payed_amount !== null"
                              >
                                mdi-exclamation
                              </v-icon>
                              <v-icon
                                color="red"
                                dark
                                v-bind="attrs"
                                v-on="on"
                                v-else
                              >
                                mdi-close
                              </v-icon>
                            </template>
                            <span v-if="item.pivot.payed_amount">{{
                              item.pivot.payed_amount | currency
                            }}</span>
                            <span v-else>0 €</span> /
                            <span v-if="item.pivot.day_type == 'full_day'">
                            {{ formValues.courseWeeks[index].price | currency }}</span>
                            <span v-else>{{ formValues.courseWeeks[index].price_half_day | currency }}</span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </v-expansion-panel-content>

                    <v-expansion-panel-content v-else>
                      <v-alert>{{ $t("no_deleted_course_registrations") }}</v-alert>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

              </v-card-text>
            </v-card>
          </template>

          <v-card-actions class="pl-0">
            <v-btn class="mr-4" @click="$router.push({ name: 'course.index' })">
              {{ $t("back") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="mr-4" @click="editItem(formValues)">
              {{ $t("edit") }}
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-col>
    </v-row>
    <v-dialog v-model="registerChildDialog" max-width="800">
      <v-card>
        <v-card-title>
          Neues Kind anmelden für "{{ registerCourseWeek.name }}"
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="registerChild"
            :items="this.children"
            :item-text="getItemText"
            item-value="id"
            :loading="isLoading"
            :search-input.sync="search"
            return-object
            clearable
          >
          </v-autocomplete>
          <v-select
            v-model="dayType"
            :items="dayTypeSelection"
            hide-details
            item-text="label"
            item-value="key"
            :label="`${$t('full_day')} / ${$t('half_day')}*`"
          >
          </v-select>
          <v-divider class="mt-2 mb-2"></v-divider>

          <h3 class="heading mt-2 mb-2">{{ $t("emergency_contacts") }}</h3>
          <v-row>
            <v-col cols="12" class="pb-0">
              <v-text-field
                color="secondary"
                :label="`${$t('emergency_contact')} 1`"
                name="emergency_contact1_phone"
                prepend-icon="mdi-phone-alert"
                v-model="emergency_contact1_phone"
                data-vv-name="emergency_contact1_phone"
                :error-messages="errors.collect('emergency_contact1_phone')"
              />
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-text-field
                color="secondary"
                :label="`${$t('emergency_contact')} 2`"
                name="emergency_contact2_phone"
                prepend-icon="mdi-phone-alert"
                v-model="emergency_contact2_phone"
                data-vv-name="emergency_contact2_phone"
                :error-messages="errors.collect('emergency_contact2_phone')"
              />
            </v-col>
          </v-row>
          <v-divider></v-divider>

          <h3 class="heading mt-5 mb-3">{{ $t("Bemerkung") }}</h3>

          <v-textarea
            v-model="comment"
            filled
            :label="$t('Bemerkung')"
          ></v-textarea>

          <v-switch
          v-model="leave_alone"
          :label="$t('leave_alone')"
        ></v-switch>

        <v-switch
          v-model="swimming_help"
          :label="$t('swimming_help')"
        ></v-switch>
        <v-textarea
        rows="2"
        outlined
        v-model="medicaments"
        :label="$t('medicaments')"
        autocomplete="new-password"
        v-validate=""
        data-vv-name="medicaments"
        :error-messages="errors.collect('medicaments')"
      ></v-textarea>
        <v-textarea
        rows="2"
        outlined
        v-model="incompatibilities"
        :label="$t('incompatibilities')"
        autocomplete="new-password"
        v-validate=""
        data-vv-name="incompatibilities"
        :error-messages="errors.collect('incompatibilities')"
      ></v-textarea>
        <v-textarea
        rows="2"
        outlined
        v-model="allergies"
        :label="$t('allergies')"
        autocomplete="new-password"
        v-validate=""
        data-vv-name="allergies"
        :error-messages="errors.collect('allergies')"
      ></v-textarea>

          <template v-if="formValues.custom_field">
            <h3 class="heading mt-5 mb-3">{{ $t("custom_field") }}</h3>
            <v-col cols="12" class="pt-0">
              <v-text-field
                v-if="$i18n.locale == 'de'"
                color="secondary"
                :label="formValues.custom_field_de"
                name="custom_field"
                v-model="custom_field"
                data-vv-name="custom_field"
                :error-messages="errors.collect('custom_field')"
              />
              <v-text-field
                v-else
                color="secondary"
                :label="formValues.custom_field_it"
                name="custom_field"
                v-model="custom_field"
                data-vv-name="custom_field"
                :error-messages="errors.collect('custom_field')"
              />
            </v-col>
          </template>
          <template v-if="formValues.custom_field_2">
            <h3 class="heading mt-5 mb-3">{{ $t("custom_field_2") }}</h3>
            <v-col cols="12" class="pt-0">
              <v-text-field
                v-if="$i18n.locale == 'de'"
                color="secondary"
                :label="formValues.custom_field_2_de"
                name="custom_field_2"
                v-model="custom_field_2"
                data-vv-name="custom_field_2"
                :error-messages="errors.collect('custom_field_2')"
              />
              <v-text-field
                v-else
                color="secondary"
                :label="formValues.custom_field_2_it"
                name="custom_field_2"
                v-model="custom_field_2"
                data-vv-name="custom_field_2"
                :error-messages="errors.collect('custom_field_2')"
              />
            </v-col>
          </template>
          <template v-if="formValues.custom_field_3">
            <h3 class="heading mt-5 mb-3">{{ $t("custom_field_3") }}</h3>
            <v-col cols="12" class="pt-0">
              <v-text-field
                v-if="$i18n.locale == 'de'"
                color="secondary"
                :label="formValues.custom_field_3_de"
                name="custom_field_3"
                v-model="custom_field_3"
                data-vv-name="custom_field_3"
                :error-messages="errors.collect('custom_field_3')"
              />
              <v-text-field
                v-else
                color="secondary"
                :label="formValues.custom_field_3_it"
                name="custom_field_3"
                v-model="custom_field_3"
                data-vv-name="custom_field_3"
                :error-messages="errors.collect('custom_field_3')"
              />
            </v-col>
          </template>
          <v-card-actions>
            <v-btn @click="postNewRegistration()">{{ $t("save") }}</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  saveItem,
  fetchItem,
  fetchCourseTypes,
  fetchLocations,
  fetchCourseCategories,
  fetchChildren,
  sendRegistration,
  deleteParticipantItem,
} from "../shared/services";
import Swal from "sweetalert2";
export default {
  name: "app-course-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {
        name: ""
      },
      chosenImage: null,
      chosenFile: null,
      permissions: [],
      loading: true,
      uploaderLoading: false,
      tab: null,
      courseCategories: [],
      courseTypes: [],
      locations: [],
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }]
      ],
      token: "",
      registerChildDialog: false,
      children: [],
      registerCourseWeek: [],
      registerChild: [],
      dayType: "",
      comment: null,
      emergency_contact2_phone: null,
      emergency_contact1_phone: null,
      search: null,
      isLoading: false,
      custom_field: null,
      custom_field_2: null,
      custom_field_3: null,
      incompatibilities: null,
      allergies:null,
      medicaments: null,
      swimming_help: null,
      leave_alone: null,
    };
  },
  mounted() {
    this.loading = true;
    this.getData().then(() => {
      if (this.$route.params.id) {
        fetchItem(this.$route.params.id).then(res => {
          this.formValues = res.data;
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
    });
    this.token = localStorage.getItem("laravel-vue-spa");
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    },
    headers() {
      let headers = [
        {
          text: this.$t("first_name"),
          align: "left",
          value: "first_name"
        },
        {
          text: this.$t("last_name"),
          align: "left",
          value: "last_name"
        },
        {
          text: this.$t("tax"),
          align: "left",
          value: "tax"
        },
        {
          text: this.$t("day_type"),
          align: "left",
          value: "pivot.day_type"
        },
        {
          text: this.$t("payed"),
          align: "left",
          value: "pivot.payed_amount"
        },
        {
          text: this.$t("waiting_list"),
          align: "left",
          value: "is_waiting"
        },
        {
          text: this.$t("emergency_contacts"),
          align: "left",
          value: "pivot.emergency_contact1_phone"
        },
        {
          text: this.$t("date"),
          align: "left",
          value: "pivot.created_at"
        }
      ];

      if (this.formValues.custom_field) {
        headers.push({
          text: this.$t("custom_field"),
          align: "left",
          value: "pivot.custom_field"
        });
      }

      if (this.formValues.custom_field_2) {
        headers.push({
          text: this.$t("custom_field_2"),
          align: "left",
          value: "pivot.custom_field_2"
        });
      }

      if (this.formValues.custom_field_3) {
        headers.push({
          text: this.$t("custom_field_3"),
          align: "left",
          value: "pivot.custom_field_3"
        });
      }

      headers.push({
          text: '#',
          align: "left",
          value: "action"
        });
      return headers;
    },
    dayTypeSelection() {
      let tmp = [];
      if (this.registerCourseWeek) {
        if (this.registerCourseWeek.full_day) {
          tmp.push({
            key: "full_day",
            label: this.$t("full_day")
          });
        }
        if (this.registerCourseWeek.half_day) {
          tmp.push({
            key: "half_day",
            label: this.$t("half_day")
          });
        }
      }
      return tmp;
    }
  },
  watch: {
      search: {
      immediate: false,
      handler: _.debounce(function () {
        if (!this.search) return; // ⬅️ prevents unnecessary fetching
        if (this.registerChild?.id) return;
        this.getChildren();
      }, 300), // 300ms debounce delay
    }
  },
  methods: {
    getData() {
      return Promise.all([
        this.getCourseTypes(),
        this.getLocations(),
        this.getCourseCategories()
      ]);
    },
    refetchData(){
      this.loading = true;
      this.getData().then(() => {
        if (this.$route.params.id) {
          fetchItem(this.$route.params.id).then(res => {
            this.formValues = res.data;
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      });
    },
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "course.index" });
      }
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Peoplecourseweekregistration?")+' ['+item.first_name+' '+item.last_name+']'
        )
      ) {
        let resp = await deleteParticipantItem(item.pivot.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.refetchData()
      }
    },
    async getCourseTypes() {
      this.courseTypes = (await fetchCourseTypes(this.options)).data;
    },
    async getLocations() {
      this.locations = (await fetchLocations(this.options)).data;
    },
    async getCourseCategories() {
      this.courseCategories = (await fetchCourseCategories(this.options)).data;
    },
    editItem(item) {
      let url = item.id;
      this.$router.push({
        name: "course.edit",
        params: { id: url }
      });
    },
    async getChildren() {
      this.isLoading = true;
      this.children = (
        await fetchChildren({ ...this.options, search: this.search, itemsPerPage: 10, page:1  })
      ).data;
      this.isLoading = false;
    },
    showRegisterChildDialog(course) {
      this.registerChildDialog = true;
      this.resetChildData();
      this.registerCourseWeek = course;
      this.getChildren();
    },
    getItemText(item) {
      return `${item.first_name} ${item.last_name} (${item.tax})`;
    },
    async postNewRegistration() {
      Swal.fire({
        title: this.$t("really_send_title"),
        text: this.$t("really_send_registration_text"),
        preConfirm: () => {
          Swal.fire({
            title: this.$t("please_wait"),
            text: this.$t("sending_request_registration"),
            didOpen: async () => {
              Swal.showLoading();
              try {
                let resp = await sendRegistration(
                  this.$route.params.id,
                  {
                    bookedChildren: [
                      {
                        children: this.registerChild,
                        courseWeeks: [
                          {
                            courseWeek: this.registerCourseWeek,
                            dayType: this.dayType
                          }
                        ]
                      }
                    ],
                    comment: this.comment,
                    emergency_contact1_phone: this.emergency_contact1_phone,
                    emergency_contact2_phone: this.emergency_contact2_phone,
                    incompatibilities: this.incompatibilities,
                    allergies: this.	allergies,
                    medicaments: this.	medicaments,
                    swimming_help: this.swimming_help,
                    leave_alone: this.leave_alone,
                    custom_field: this.custom_field,
                    custom_field_2: this.custom_field_2,
                    custom_field_3: this.custom_field_3,
                  },
                  this.$validator
                );
                Swal.close();
                Swal.fire({
                  icon: resp.waitingQueueWarnings ? "warning" : "success",
                  html: resp.message.join("<br>")
                });
                this.registerChildDialog = false;
                this.resetChildData();
                this.loading = true;
                fetchItem(this.$route.params.id).then(res => {
                  this.formValues = res.data;
                  this.loading = false;
                });
              } catch (error) {
                if (error.response && error.response.status == 422) {
                  let errorBag = [];
                  for (let field in error.response.data.errors) {
                    errorBag.push(error.response.data.errors[field][0]);
                  }
                  Swal.fire({
                    title: this.$t("Fehler"),
                    html: errorBag.join("<br>"),
                    icon: "error"
                  });
                } else {
                  Swal.fire({
                    title: this.$t("Fehler"),
                    text: this.$t("generic_api_send_error"),
                    icon: "error"
                  });
                }
              }
            },
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEnterClick: false,
            allowEscapeKey: false
          });
        },
        icon: "question",
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: this.$t("Cancel"),
        confirmButtonText: this.$t("Send"),
        confirmButtonColor: "green"
      });
    },
    resetChildData() {
      this.registerCourseWeek = [];
      this.registerChild = [];
      this.dayType = "";
      this.comment = null;
      this.emergency_contact2_phone = null;
      this.emergency_contact1_phone = null;
      this.custom_field = null;
      this.custom_field_2 = null;
      this.custom_field_3 = null;
      this.incompatibilities = null;
      this.allergies = null;
      this.medicaments = null;
      this.swimming_help = null;
      this.leave_alone = null;
      this.search = null;
    }
  }
};
</script>

<style lang="scss" scoped></style>
